module.exports = __webpack_public_path__ + "img/evaluating_img2.443b4963.jpg";